import { render, staticRenderFns } from "./wuye.vue?vue&type=template&id=b01ea830&scoped=true&"
import script from "./wuye.vue?vue&type=script&lang=js&"
export * from "./wuye.vue?vue&type=script&lang=js&"
import style0 from "./wuye.vue?vue&type=style&index=0&id=b01ea830&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01ea830",
  null
  
)

export default component.exports